import React, { useCallback, useEffect, useState } from "react";
import Navbar from "./../components/Navbar";
import { Link } from "react-router-dom";
import Fotter from "../components/Fotter";
import { BASE_URL } from "./Config";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { CountdownTimer } from "../components/CountDownTimer";
import { CountdownTimerSlider } from "../components/CountDownTimerSlider";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css/navigation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { formatDate } from "../components/dateUtils";

import "./Home.css";
export default function Home() {
  const [NewADD, setNewADD] = useState([]);
  const [NoWin, setNoWin] = useState([]);
  const [MostActive, setMostActive] = useState([]);
  const [MostActiveCount, setMostActiveCount] = useState([]);
  const [closingsoon, setClosingSoon] = useState([]);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [relistuser, setrelistuser] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userinfo, setUserdatainfo] = useState([]);

  const [silverproduct, settopsilverproduct] = useState([]);
  const [goldproduct, settopgoldproduct] = useState([]);

  const [topproducts, setTopProduct] = useState([]);

  const userIlogin = Cookies.get("user_id");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${userIlogin}&t=${Date.now()}`)
      .then((res) => {
        if (res.data.success) {
          //  const userData = res.data.data[0];
          setUserdatainfo(res.data.data);
          // console.log("userdata", res.data.data);
        } else {
          //   console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, [userIlogin]);

  // Closing Soon Function
  useEffect(() => {
    const fetchClosingSoonProducts = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/closing_soon.php?type=limit&t=${Date.now()}`
        );

        //  console.log("Closing Soon", response.data);

        if (response.data.success) {
          const sortedProducts = response.data.closing_soon.sort((a, b) => {
            return new Date(a.closing_time) - new Date(b.closing_time);
          });
          setClosingSoon(sortedProducts);
          setLoading(false);
        } else {
          setClosingSoon([]);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setClosingSoon([]);
      }
    };

    fetchClosingSoonProducts();
    const intervalId = setInterval(fetchClosingSoonProducts, 2000); // ✅ Call every 1 second

    return () => clearInterval(intervalId);
  }, []);

  // Most Active Function
  useEffect(() => {
    const fetchMostActiveProducts = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/most_active.php?type=limit&t=${Date.now()}`
        );

        //  console.log("Most Active", response.data.most_active);

        if (response.data.success) {
          setMostActive(response.data.most_active);
          setMostActiveCount(response.data.most_active_count);
          setLoading(false);
        } else {
          setMostActive([]);
          setMostActiveCount();
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setMostActive([]);
        setMostActiveCount();
      }
    };
    fetchMostActiveProducts();
    const intervalId = setInterval(fetchMostActiveProducts, 4000); // ✅ Call every 1 second

    return () => clearInterval(intervalId);
  }, []);

  // Newly Add Function
  useEffect(() => {
    const fetchNewlyAddProducts = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/newly_add.php?type=limit&t=${Date.now()}`
        );

        //  console.log("Newly Add", response.data);

        if (response.data.success) {
          setNewADD(response.data.new_add);
          setLoading(false);
        } else {
          setNewADD([]);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setNewADD([]);
      }
    };
    fetchNewlyAddProducts();
    const intervalId = setInterval(fetchNewlyAddProducts, 2000); // ✅ Call every 1 second

    return () => clearInterval(intervalId);
  }, []);

  // No Win Function
  useEffect(() => {
    const fetchNoWinProducts = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/no_wins.php?type=limit&t=${Date.now()}`
        );

        //  console.log("No Wins", response);

        if (response.data.success) {
          setNoWin(response.data.no_win); // ✅ correct key
          setLoading(false);
        } else {
          setNoWin([]); // ✅ not MostActive
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setNoWin([]);
      }
    };
    fetchNoWinProducts();
    const intervalId = setInterval(fetchNoWinProducts, 5000); // 5 seconds

    return () => clearInterval(intervalId);
  }, []);

  // No Win Function
  useEffect(() => {
    const fetchTopProducts = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/top_products.php?type=limit&t=${Date.now()}`
        );

        // console.log("Top Products", response);

        if (response.data.success) {
          setTopProduct(response.data.no_win); // ✅ correct key
          setLoading(false);
        } else {
          setTopProduct([]); // ✅ not MostActive
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setTopProduct([]);
      }
    };

    fetchTopProducts();
    const intervalId = setInterval(fetchTopProducts, 5000); // 5 seconds

    return () => clearInterval(intervalId);
  }, []);

  // Item Get Relist Function
  useEffect(() => {
    const relistuser = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/get_relist_user.php?t=${Date.now()}`
        );

        //   console.log("Relist User", response.data);

        if (response.data.success) {
          setrelistuser(response.data);
          setLoading(false);
        } else {
          setrelistuser([]);
        }
      } catch (error) {
        console.error("Failed to fetch relist user", error);
        setrelistuser([]);
      }
    };

    const intervalId = setInterval(relistuser, 3000); // ✅ Call every 1 second

    return () => clearInterval(intervalId);
  }, []);

  const [relistloading, setRelistLoading] = useState([]);

  // Item Relist Function
  const relist = async (product_id: number, product_user_id: number) => {
    if (!user_id) {
      toast.warning("Login Required"); // use warning instead of success
      return;
    }

    if (product_user_id === user_id) {
      toast.warning("You can't make a request on your own product.");
      return;
    }

    if (userinfo.status === 0) {
      toast.warning("Your Account is suspended !");
      console.log("Your Account is suspended !");
      return;
    }

    setRelistLoading((prev) => ({ ...prev, [product_id]: true }));

    const response = {
      product_id: product_id,
      product_user_id: product_user_id,
      user_id: user_id,
    };

    // console.log("Sending data:", response);

    try {
      const res = await axios.post(`${BASE_URL}/relist_request.php`, response, {
        headers: { "Content-Type": "application/json" },
      });

      console.log(res);

      if (res.data.success) {
        // setToastMessage(res.data.message || "Added!");
        toast.success(res.data.message || "Request Sended !");
        setRelistLoading(false);
      } else {
        toast.warning(res.data.message);
        // setToastMessage(res.data.message);
        setRelistLoading(false);
      }

      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000); // Hide after 3 seconds
    } catch (error) {
      console.error(error);
      setToastMessage("Server error. Try again.");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
      setRelistLoading(false);
    }
  };

  const [bookmarks, setBookmarks] = useState([]);

  const fetchBookmarks = async () => {
    if (!user_id) {
      //  console.error("User ID not found in cookies.");
      return;
    }
    try {
      const res = await fetch(
        `${BASE_URL}/all_fav_item.php?id=${user_id}&t=${Date.now()}`,
        {
          cache: "no-store",
        }
      );

      //  console.log(res);
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      //   console.log("Fetched data:", data);

      if (data.success) {
        setBookmarks(data.data);
      } else {
        setBookmarks([]);
      }
    } catch (err) {
      console.error("Error fetching bookmarks:", err);
    }
  };

  // const [massage, setToastMessage] = useState("");
  const [status, setToastStatus] = useState(false);

  const [favloading, setfavloading] = useState(false);

  const user_id = Cookies.get("user_id");
  const username = Cookies.get("username");

  const addToFavorite = async (id: string) => {
    if (!user_id) {
      toast.warning("Login Required");
      return;
    }

    const response = {
      id: id,
      username: username,
      user_id: user_id,
    };

    //  console.log("Sending data:", response);

    setfavloading((prev) => ({ ...prev, [id]: true }));

    try {
      const res = await axios.post(
        `${BASE_URL}/add_favorite.php?type=add`,
        response,
        { headers: { "Content-Type": "application/json" } }
      );

      // console.log(res);

      if (res.data.success) {
        toast.success("Added to wishlist!");

        // Refresh favorites
        fetchBookmarks();
      } else {
        toast.error(res.data.message || "Could not add to wishlist.");
        fetchBookmarks();
      }

      setfavloading(false);
    } catch (error) {
      console.error(error);
      toast.error("Server error. Try again.");
      setfavloading(false);
    }
  };

  const removefav = async (id: string) => {
    if (!user_id) {
      toast.warning("Login Required"); // use warning instead of success
      console.log("first");
      return;
    }

    const response = {
      id,
      username,
      user_id,
    };

    // console.log(response);

    setfavloading((prev) => ({ ...prev, [id]: true }));

    try {
      const res = await axios.post(
        `${BASE_URL}/add_favorite.php?type=remove`,
        response
      );

      // console.log(res);
      if (res.data.success) {
        toast.error("Removed from favorites!");
        // Refresh bookmarks list
        fetchBookmarks();
      } else {
        toast.error("Something went wrong.");
        setToastStatus(true);
        fetchBookmarks();
      }

      setfavloading(true);
    } catch (error) {
      console.error(error);
      toast.error("Server error. Try again.");
      fetchBookmarks();

      setfavloading(true);
    }

    setToastStatus(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      fetchBookmarks();
    }, 4000); // every 1000 milliseconds = 1 second

    return () => clearInterval(interval); // clear interval on unmount or id change
  }, []);

  const [buyNowLimit, setBuyNowLimit] = useState(0); // number instead of array

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_company_detail.php?type=buy_now&t=${Date.now()}`)
      .then((res) => {
        //  console.log("Full response:", res.data);
        if (
          res.data.success &&
          Array.isArray(res.data.data) &&
          res.data.data.length > 0
        ) {
          setBuyNowLimit(Number(res.data.data[0].number)); // store number directly
        } else {
          console.warn("API success true, but data is not array");
          setBuyNowLimit(0);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setBuyNowLimit(0);
      });
  }, []);

  const [ads, setAds] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_ads.php?type=home_one&t=${Date.now()}`)
      .then((res) => {
        //    console.log("Ads responsess :", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setAds(res.data.data);
        } else {
          console.warn("API success true, but data is not array");
          setAds([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setAds([]);
      });
  }, []);

  const [currentAd, setCurrentAd] = useState(0);

  useEffect(() => {
    if (ads.length === 0) return;

    const interval = setInterval(() => {
      setCurrentAd((prev) => (prev + 1) % ads.length);
    }, 15000); // 15000ms = 15 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, [ads]);

  const ad = ads[currentAd];

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_top_products.php?type=Gold`)
      .then((res) => {
        // console.log(res);
        if (res.data.success) {
          settopgoldproduct(res.data.data);
          // console.log("gold product", res.data.data);
        } else {
          //   console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, []);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_top_products.php?type=silver`)
      .then((res) => {
        //  console.log(res);
        if (res.data.success) {
          //  const userData = res.data.data[0];
          settopsilverproduct(res.data.data);
          // console.log("userdata", res.data.data);
        } else {
          //   console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, []);

  return (
    <>
      <Navbar />

      <div className="latest-auction-section mb-110   mt-5">
        <div className="container mb-5">
          <div className="row">
            <div className="col-12">
              <div className="advertisement" style={{ textAlign: "center" }}>
                {ads.length > 0 ? (
                  <Link to={ad.link || "#"}>
                    <img
                      src={
                        `${BASE_URL}/uploads/ads/${ad.image}` ||
                        "/assets/default-ad.jpg"
                      }
                      alt={ad.title || "Advertisement"}
                      style={{
                        width: "100%",
                        maxHeight: "150px",
                        objectFit: "contain",
                        borderRadius: "2px",
                        transition: "opacity 0.5s ease-in-out",
                      }}
                    />
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row mb-60">
            <div className="col-lg-12 d-flex align-items-end justify-content-between flex-wrap gap-3">
              <div
                className="section-title wow animate fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <h2>
                  CLOSING <span>SOON</span>
                </h2>
                {/* <p>
                  Feel free adapt this based on the specific managed services,
                  features
                </p> */}
              </div>
              <Link
                to="/product-list/closingsoon"
                className="view-button wow animate fadeInRight"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                href="auction-grid.html"
                style={{ visibility: "hidden", display: "none" }}
              >
                View All Auction
                <svg viewBox="0 0 13 20">
                  <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
                </svg>
              </Link>
            </div>
          </div>
          <div className="row g-4">
            {loading
              ? [...Array(8)].map((_, index) => (
                <div
                  key={index}
                  className="col-xl-3 col-lg-3 col-md-4 col-sm-6 wow animate fadeInDown"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="auction-card">
                    <div className="auction-card-img-wrap">
                      <div className="card-img">
                        <Skeleton height={200} />
                      </div>
                    </div>
                    <div className="auction-card-content">
                      <h6>
                        <Skeleton width={`80%`} />
                      </h6>
                      <div className="price-and-code-area">
                        <div className="price">
                          <Skeleton width={100} />
                        </div>
                        <div className="code">
                          <Skeleton width={50} />
                        </div>
                      </div>
                      <div className="author-and-btn-area">
                        <div className="author-area d-flex align-items-center">
                          <Skeleton circle height={40} width={40} />
                          <Skeleton width={100} style={{ marginLeft: 10 }} />
                        </div>
                        <div
                          className="bid-btn"
                          style={{ background: "transparent" }}
                        >
                          <Skeleton width={80} height={30} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
              : closingsoon?.length > 0
                ? closingsoon.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="col-xl-3 col-lg-3 col-md-4 col-sm-6 m-0 p-0 wow animate fadeInDown"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      <div className="auction-card fontstyle2">
                        <div
                          className="auction-card-img-wrap"
                          style={{ position: "relative" }}
                        >
                          <Link to={`/detail/${item.id}`} className="card-img">
                            <img
                              src={
                                item.photo
                                  ? `${BASE_URL}/${item.photo
                                    .split(",")[0]
                                    .trim()}`
                                  : `${BASE_URL}/uploads/logo/icon.png`
                              }
                              alt={item.title}
                              title={item.title}
                              loading="lazy"
                            />
                          </Link>
                          <ul className="bookmark_icon">
                            <li>
                              {favloading[item.id] ? (
                                <span className="fav-spinner"></span>
                              ) : (
                                <Link
                                  to="/#"
                                  onClick={() => {
                                    bookmarks.some((b) => b.id === item.id)
                                      ? removefav(item.id)
                                      : addToFavorite(item.id);
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faHeart}
                                    style={{
                                      color: bookmarks.some(
                                        (b) => b.id === item.id
                                      )
                                        ? "#F2B42A"
                                        : "",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </Link>
                              )}
                            </li>
                          </ul>

                          {item.membership_type !== "Basic" && (
                            <p
                              className="tag"
                              style={{
                                position: "absolute",
                                top: 0,
                                margin: 0,
                                background:
                                  item.membership_type === "Gold"
                                    ? "#F2B42A"
                                    : item.membership_type === "Silver"
                                      ? "#C0C0C0"
                                      : "#ffffff",
                                padding: "0px 10px",
                                textAlign: "center",
                                borderRadius: "2px",
                                color: "black",
                                fontWeight: 500,
                              }}
                            >
                              {item.membership_type}
                            </p>
                          )}
                          <CountdownTimer closingTime={item.closing_time} />
                        </div>
                        <div className="auction-card-content">
                          <div
                            className="price-and-code-area"
                            style={{ marginBottom: "5px" }}
                          >
                            <div className="price">
                              <span
                                style={{
                                  fontSize: "15px",
                                  color: "#91948F",
                                  fontWeight: "500",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "1px",
                                }}
                              >
                                <FaMapMarkerAlt
                                  style={{ color: "#91948F", fontSize: "14px" }}
                                />{" "}
                                {item.city?.length > 15
                                  ? item.city.substring(0, 15) + "..."
                                  : item.city}
                              </span>
                            </div>
                            <div className="code"># {item.id}</div>
                          </div>
                          <h6 className="product_title">
                            <Link to={`/detail/${item.id}`}>
                              {item.title ||
                                "Vintage valor embracing the elegance of eras past."}
                            </Link>
                          </h6>

                          <div className="price-and-code-area">
                            <div className="price">
                              <span>Current Bid at:</span>
                              <strong>
                                {item.current_price === ""
                                  ? item.auction_start_price
                                  : item.current_price}{" "}
                                SAR
                              </strong>
                            </div>

                            {Number(item.current_price) /
                              Number(item.buy_now) >=
                              buyNowLimit ? (
                              ""
                            ) : Number(item.buy_now) == 0 ? (
                              ""
                            ) : (
                              <div className="price">
                                <span>Buy Now at:</span>
                                <strong>{Number(item.buy_now)} SAR</strong>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
                : !loading && <p>No products found.</p>}
          </div>

          <div className="row mb-60">
            <div className="col-lg-12 d-flex align-items-end justify-content-between flex-wrap gap-3">
              <div
                className="section-title wow animate fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                style={{ visibility: "hidden" }}
              >
                <h2 style={{ display: "none", marginTop: "5px" }}>
                  CLOSING <span>SOON</span>
                </h2>
                {/* <p>
                  Feel free adapt this based on the specific managed services,
                  features
                </p> */}
              </div>
              <Link
                to="/product-list/closingsoon"
                className="view-button wow animate fadeInRight"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                href="auction-grid.html"
              >
                View All Auction
                <svg viewBox="0 0 13 20">
                  <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="for_desktop" style={{ padding: "5px", display: "block" }}>
        <div className="container">
          <div className="features row">
            <div className="feature col-xl-3 col-lg-3 col-md-3 col-sm-6 ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="currentColor"
                className="bi bi-box-seam"
                viewBox="0 0 16 16"
              >
                <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z" />
              </svg>
              <div style={{ width: "100%" }}>
                <p className="title">Fastest Delivery</p>
                <p className="description">Delivery in the nearest time</p>
              </div>
            </div>
            <div className="feature col-xl-3 col-lg-3 col-md-3 col-sm-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="currentColor"
                className="bi bi-trophy"
                viewBox="0 0 16 16"
              >
                <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5q0 .807-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33 33 0 0 1 2.5.5m.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935m10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935M3.504 1q.01.775.056 1.469c.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.5.5 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667q.045-.694.056-1.469z" />
              </svg>
              <div style={{ width: "100%" }}>
                <p className="title">Equitable Plans</p>
                <p className="description">Enjoy personalized solutions</p>
              </div>
            </div>
            <div className="feature col-xl-3 col-lg-3 col-md-3 col-sm-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="currentColor"
                className="bi bi-credit-card-2-front"
                viewBox="0 0 16 16"
              >
                <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
                <path d="M2 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5" />
              </svg>
              <div style={{ width: "100%" }}>
                <p className="title">Secure Payment</p>
                <p className="description">Your money is safe</p>
              </div>
            </div>
            <div className="feature col-xl-3 col-lg-3 col-md-3 col-sm-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="currentColor"
                className="bi bi-headphones"
                viewBox="0 0 16 16"
              >
                <path d="M8 3a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a6 6 0 1 1 12 0v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1V8a5 5 0 0 0-5-5" />
              </svg>
              <div style={{ width: "100%" }}>
                <p className="title">Support 24/7</p>
                <p className="description">Live contact/message</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="for_mobile" style={{ padding: "5px", display: "none" }}>
        <div className="container">
          <div className=" mobile_features row">
            <div className="mobile_feature col-xl-3 col-lg-3 col-md-3 col-sm-6 ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="currentColor"
                className="bi bi-box-seam"
                viewBox="0 0 16 16"
              >
                <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z" />
              </svg>
              <div>
                <p className="title">Fastest Delivery</p>
                <p className="description">Delivery in the nearest time</p>
              </div>
            </div>
            <div className="mobile_feature col-xl-3 col-lg-3 col-md-3 col-sm-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="currentColor"
                className="bi bi-trophy"
                viewBox="0 0 16 16"
              >
                <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5q0 .807-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33 33 0 0 1 2.5.5m.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935m10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935M3.504 1q.01.775.056 1.469c.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.5.5 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667q.045-.694.056-1.469z" />
              </svg>
              <div>
                <p className="title">Equitable Plans</p>
                <p className="description">Enjoy personalized solutions</p>
              </div>
            </div>
            <div className="mobile_feature col-xl-3 col-lg-3 col-md-3 col-sm-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="currentColor"
                className="bi bi-credit-card-2-front"
                viewBox="0 0 16 16"
              >
                <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
                <path d="M2 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5" />
              </svg>
              <div>
                <p className="title">Secure Payment</p>
                <p className="description">Your money is safe</p>
              </div>
            </div>
            <div className="mobile_feature col-xl-3 col-lg-3 col-md-3 col-sm-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="currentColor"
                className="bi bi-headphones"
                viewBox="0 0 16 16"
              >
                <path d="M8 3a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a6 6 0 1 1 12 0v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1V8a5 5 0 0 0-5-5" />
              </svg>
              <div>
                <p className="title">Support 24/7</p>
                <p className="description">Live contact/message</p>
              </div>
            </div>
          </div>
        </div>
        <br></br>
      </div>

      <div className="latest-auction-section mb-110">
        <div className="container">
          <div className="row mb-60">
            <div className="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div
                className="section-title wow animate fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <h2>
                  NEWLY <span>Added</span>
                </h2>
                {/* <p>
                  Feel free adapt this based on the specific managed services,
                  features
                </p> */}
              </div>
              <Link
                to="/product-list/newly"
                className="view-button wow animate fadeInRight"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                href="auction-grid.html"
                style={{ visibility: "hidden", display: "none" }}
              >
                View All Auction
                <svg viewBox="0 0 13 20">
                  <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
                </svg>
              </Link>
            </div>
          </div>
          <div className="row g-4">
            {loading
              ? // Skeleton Loader (8 cards)
              [...Array(8)].map((_, index) => (
                <div
                  key={index}
                  className="col-xl-3 col-lg-3 col-md-4 col-sm-6 wow animate fadeInDown"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="auction-card">
                    <div className="auction-card-img-wrap">
                      <div className="card-img">
                        <Skeleton height={200} />
                      </div>
                    </div>
                    <div className="auction-card-content">
                      <h6>
                        <Skeleton width={`80%`} />
                      </h6>
                      <div className="price-and-code-area">
                        <div className="price">
                          <Skeleton width={100} />
                        </div>
                        <div className="code">
                          <Skeleton width={50} />
                        </div>
                      </div>
                      <div className="author-and-btn-area">
                        <div className="author-area d-flex align-items-center">
                          <Skeleton circle height={40} width={40} />
                          <Skeleton width={100} style={{ marginLeft: 10 }} />
                        </div>
                        <div
                          className="bid-btn"
                          style={{ background: "transparent" }}
                        >
                          <Skeleton width={80} height={30} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
              : (NewADD && Array.isArray(NewADD) ? NewADD : []).map(
                (item, index) => {
                  return (
                    <div
                      key={index}
                      className="col-xl-3 col-lg-3 col-md-4 col-sm-6 m-0 p-0 wow animate fadeInDown"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      <div className="auction-card">
                        <div
                          className="auction-card-img-wrap"
                          style={{ position: "relative", overflow: "hidden" }}
                        >
                          <Link
                            to={`/detail/${item.id}`}
                            className="card-img"
                          >
                            <img
                              src={
                                item.photo
                                  ? `${BASE_URL}/${item.photo
                                    .split(",")[0]
                                    .trim()}`
                                  : `${BASE_URL}/uploads/logo/icon.png`
                              }
                              loading="lazy"
                              alt={item.title || "FastTrade Product"}
                              title={item.title || "FastTrade Product"}
                            />
                          </Link>

                          {/* Favorite / Bookmark */}
                          <ul className="bookmark_icon">
                            <li>
                              {favloading[item.id] ? (
                                <span className="fav-spinner"></span>
                              ) : (
                                <Link
                                  to="#"
                                  onClick={() => {
                                    (bookmarks || []).some(
                                      (items) => items.id === item.id
                                    )
                                      ? removefav(item.id)
                                      : addToFavorite(item.id);
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faHeart}
                                    style={{
                                      color: (bookmarks || []).some(
                                        (items) => items.id === item.id
                                      )
                                        ? "#F2B42A"
                                        : "",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </Link>
                              )}
                            </li>
                          </ul>

                          {/* Membership Tag */}
                          {item.membership_type &&
                            item.membership_type !== "Basic" && (
                              <p
                                className="tag"
                                style={{
                                  position: "absolute",
                                  top: 15,
                                  left: "-23px",
                                  margin: 0,
                                  background:
                                    item.membership_type === "Gold"
                                      ? "#F2B42A"
                                      : item.membership_type === "Silver"
                                        ? "#C0C0C0"
                                        : "#ffffff", // fallback
                                  padding: "0px 22px",
                                  textAlign: "center",
                                  borderRadius: "2px",
                                  color: "black",
                                  fontWeight: 800,
                                  transform: "rotate(309deg)"
                                }}
                              >
                                {item.membership_type}
                              </p>
                            )}

                          {/* Timer */}
                          <CountdownTimer closingTime={item.closing_time} />
                        </div>

                        <div className="auction-card-content">
                          {/* Location & ID */}
                          <div
                            className="price-and-code-area"
                            style={{ marginBottom: "5px" }}
                          >
                            <div className="price">
                              <span
                                style={{
                                  fontSize: "15px",
                                  color: "#91948F",
                                  fontWeight: "500",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "1px",
                                }}
                              >
                                <FaMapMarkerAlt
                                  style={{
                                    color: "#91948F",
                                    fontSize: "14px",
                                  }}
                                />{" "}
                                {item.city
                                  ? item.city.length > 15
                                    ? item.city.substring(0, 15) + "..."
                                    : item.city
                                  : "Unknown"}
                              </span>
                            </div>
                            <div className="code"># {item.id}</div>
                          </div>

                          {/* Title */}
                          <h6 className="product_title">
                            <Link to={`/detail/${item.id}`}>
                              {item.title ||
                                "Vintage valor embracing the elegance of eras past."}
                            </Link>
                          </h6>

                          {/* Prices */}
                          <div className="price-and-code-area">
                            <div className="price">
                              <span>Current Bid at:</span>
                              <strong>
                                {item.current_price === "" ||
                                  item.current_price == null
                                  ? item.auction_start_price
                                  : item.current_price}{" "}
                                SAR
                              </strong>
                            </div>

                            {Number(item.current_price) /
                              Number(item.buy_now) >=
                              buyNowLimit ? (
                              ""
                            ) : Number(item.buy_now) == 0 ? (
                              ""
                            ) : (
                              <div className="price">
                                <span>Buy Now at:</span>
                                <strong>{Number(item.buy_now)} SAR</strong>
                              </div>
                            )}

                            {/* {item.buy_now && item.buy_now !== "0" && (
                                <div className="price">
                                  <span>Buy Now at:</span>
                                  <strong>{item.buy_now} SAR</strong>
                                </div>
                              )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
          </div>

          <div className="row mb-60">
            <div className="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div
                className="section-title wow animate fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                style={{ visibility: "hidden" }}
              >
                <h2 style={{ display: "none", marginTop: "5px" }}>
                  NEWLY <span>Added</span>
                </h2>
                {/* <p>
                  Feel free adapt this based on the specific managed services,
                  features
                </p> */}
              </div>
              <Link
                to="/product-list/newly"
                className="view-button wow animate fadeInRight"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                href="auction-grid.html"
              >
                View All Auction
                <svg viewBox="0 0 13 20">
                  <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="home1-banner2-section mb-110">
        <div className="banner2-wrapper">
          <div className="row g-xl-3 gy-5">
            <div className="col-xl-8">
              <div className="swiper home1-banner2-slider">
                <div className="swiper-wrapper">
                  <div
                    className="swiper-slide swiper-slide-duplicate"
                    data-swiper-slide-index="0"
                  >
                    <div
                      className="banner2-left-area"
                      style={{
                        backgroundImage:
                          " linear-gradient(rgb(230 171 40) 0%, rgb(230 171 40) 100%)",
                      }}
                    >
                      <div
                        className="batch wow animate swing"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <span>
                          HURRY <br /> UP!
                        </span>
                      </div>
                      <Swiper
                        modules={[Pagination, Autoplay]}
                        // pagination={{ clickable: true }}
                        loop={true}
                        autoplay={{ delay: 5000 }}
                        className="mySwiper"
                      >
                        {goldproduct.map((item, index) => (
                          <SwiperSlide key={index}>
                            <div className="product_box">
                              <div className="banner2-left-content">
                                <div className="price-area">
                                  <span>Current Bid at:</span>
                                  <h3>
                                    {" "}
                                    {item.current_price == ""
                                      ? item.auction_start_price
                                      : item.current_price}{" "}
                                    SAR
                                  </h3>
                                </div>
                                <h2>
                                  <Link to={`/detail/${item.id}`}>
                                    {item.title.length > 20
                                      ? item.title.slice(0, 80) + "..."
                                      : item.title}
                                  </Link>
                                </h2>

                                <CountdownTimerSlider
                                  closingTime={item.closing_time}
                                />

                                <Link
                                  to={`/detail/${item.id}`}
                                  className="primary-btn btn-hover black-bg"
                                >
                                  Bid Now
                                </Link>
                              </div>

                              <div
                                className="product_img"
                                style={{ paddingTop: "15px" }}
                              >
                                <img
                                  src={
                                    item.photo
                                      ? `${BASE_URL}/${item.photo
                                        .split(",")[0]
                                        .trim()}`
                                      : `${BASE_URL}/uploads/logo/icon.png`
                                  }
                                  loading="lazy"
                                  alt={item.title || "FastTrade Product"}
                                  title={item.title || "FastTrade Product"}
                                />
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                </div>
                <div className="pagination-area">
                  <div className="swiper-pagination2"></div>
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="banner2-right-area">
                <Swiper
                  modules={[Pagination, Autoplay]}
                  // pagination={{ clickable: true }}
                  loop={true}
                  autoplay={{ delay: 5000 }}
                  className="mySwiper"
                >
                  {silverproduct.map((item, index) => (
                    <SwiperSlide>
                      <div>
                        <div className="banner2-right-content">
                          <h4>
                            <Link to={`/detail/${item.id}`}>
                              {item.title.length > 20
                                ? item.title.slice(0, 80) + "..."
                                : item.title}
                            </Link>
                          </h4>
                          <div className="price-area">
                            <span>Current Bid at:</span>
                            <h3>
                              {" "}
                              {item.current_price == ""
                                ? item.auction_start_price
                                : item.current_price}{" "}
                              SAR
                            </h3>
                          </div>
                          <b style={{ fontSize: "25px" }}>
                            {" "}
                            {formatDate(item.closing_time)}
                          </b>
                        </div>
                        <div
                          className="banner2-right-img"
                          style={{ padding: "25px", textAlign: "center" }}
                        >
                          <img
                            src={
                              item.photo
                                ? `${BASE_URL}/${item.photo
                                  .split(",")[0]
                                  .trim()}`
                                : `${BASE_URL}/uploads/logo/icon.png`
                            }
                            style={{ height: "250px" }}
                            alt=""
                          />
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                  {/* Add more <SwiperSlide> items here if needed */}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="latest-auction-section mb-110">
        <div className="container">
          <div className="row mb-60">
            <div className="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div
                className="section-title wow animate fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <h2>
                  Most Active<span>Bids</span>
                </h2>
                {/* <p>
                  Feel free adapt this based on the specific managed services,
                  features
                </p> */}
              </div>
              <Link
                to="/product-list/mostactive"
                className="view-button wow animate fadeInRight"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                href="auction-grid.html"
                style={{ visibility: "hidden", display: "none" }}
              >
                View All Auction
                <svg viewBox="0 0 13 20">
                  <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
                </svg>
              </Link>
            </div>
          </div>
          <div className="row g-4">
            {loading
              ? [...Array(8)].map((_, index) => (
                <div
                  key={index}
                  className="col-xl-3 col-lg-3 col-md-4 col-sm-6 wow animate fadeInDown"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="auction-card">
                    <div className="auction-card-img-wrap">
                      <div className="card-img">
                        <Skeleton height={200} />
                      </div>
                    </div>
                    <div className="auction-card-content">
                      <h6>
                        <Skeleton width={`80%`} />
                      </h6>
                      <div className="price-and-code-area">
                        <div className="price">
                          <Skeleton width={100} />
                        </div>
                        <div className="code">
                          <Skeleton width={50} />
                        </div>
                      </div>
                      <div className="author-and-btn-area">
                        <div className="author-area d-flex align-items-center">
                          <Skeleton circle height={40} width={40} />
                          <Skeleton width={100} style={{ marginLeft: 10 }} />
                        </div>
                        <div
                          className="bid-btn"
                          style={{ background: "transparent" }}
                        >
                          <Skeleton width={80} height={30} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
              : MostActive.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="col-xl-3 col-lg-3 col-md-4 col-sm-6 m-0 p-0 wow animate fadeInDown"
                    data-wow-delay="200ms"
                    data-wow-duration="1500ms"
                  >
                    {/* Replace hardcoded values below with dynamic item values as needed */}
                    <div className="auction-card">
                      <div className="auction-card-img-wrap">
                        <Link to={`/detail/${item.id}`} className="card-img">
                          <img
                            src={
                              item.photo
                                ? `${BASE_URL}/${item.photo
                                  .split(",")[0]
                                  .trim()}`
                                : `${BASE_URL}/uploads/logo/icon.png`
                            }
                            loading="lazy"
                            alt={item.title || "FastTrade Product"}
                            title={item.title || "FastTrade Product"}
                          />
                        </Link>
                        <ul>
                          <li className="biders">
                            <span>{item.total_unique_bidders} Bids</span>
                          </li>
                          <li className="bookmark_icon">
                            {favloading[item.id] ? (
                              <span className="fav-spinner"></span>
                            ) : (
                              <Link
                                to="/#"
                                onClick={() => {
                                  bookmarks.some(
                                    (items) => items.id === item.id
                                  )
                                    ? removefav(item.id)
                                    : addToFavorite(item.id);
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faHeart}
                                  style={{
                                    color: bookmarks.some(
                                      (items) => items.id === item.id
                                    )
                                      ? "#F2B42A"
                                      : "",
                                    borderRadius: "50%",
                                  }}
                                />
                              </Link>
                            )}
                          </li>
                          {/* <li>
                          <Link to={`/detail/${item.id}`}>
                          </Link>
                        </li> */}
                        </ul>
                        {item.membership_type !== "Basic" && (
                          <p
                            className="tag"
                            style={{
                              position: "absolute",
                              top: 0,
                              margin: 0,
                              background:
                                item.membership_type === "Gold"
                                  ? "#F2B42A"
                                  : item.membership_type === "Silver"
                                    ? "#C0C0C0"
                                    : "#ffffff", // fallback
                              padding: "0px 10px",
                              textAlign: "center",
                              borderRadius: "2px",
                              color: "black",
                              fontWeight: 500,
                            }}
                          >
                            {item.membership_type}
                          </p>
                        )}
                        <CountdownTimer closingTime={item.closing_time} />
                      </div>
                      <div className="auction-card-content">
                        {/* <UserReviewInfo userId={item.user_id} /> */}
                        <div
                          className="price-and-code-area"
                          style={{ marginBottom: "5px" }}
                        >
                          <div className="price">
                            <span
                              style={{
                                fontSize: "15px",
                                color: "#91948F",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gap: "1px",
                              }}
                            >
                              {" "}
                              <FaMapMarkerAlt
                                style={{ color: "#91948F", fontSize: "14px" }}
                              />{" "}
                              {item.city?.length > 15
                                ? item.city.substring(0, 15) + "..."
                                : item.city}
                            </span>
                          </div>
                          <div className="code"># {item.id}</div>
                        </div>

                        <h6 className="product_title">
                          <Link to={`/detail/${item.id}`}>
                            {item.title ||
                              "Vintage valor embracing the elegance of eras past."}
                          </Link>
                        </h6>
                        <div className="price-and-code-area">
                          <div className="price">
                            <span>Current Bid at:</span>
                            <strong>
                              {item.current_price == ""
                                ? item.auction_start_price
                                : item.current_price}{" "}
                              SAR
                            </strong>
                          </div>
                          {Number(item.current_price) /
                            Number(item.buy_now) >=
                            buyNowLimit ? (
                            ""
                          ) : (
                            <div className="price">
                              <span>Buy Now at:</span>
                              <strong>{Number(item.buy_now) || 0} SAR</strong>
                            </div>
                          )}
                        </div>

                        {/* <div className="author-and-btn-area">
                            <Link
                              to={`/detail/${item.id}`}
                              className="author-area"
                            >
                              <div className="author-img">
                                <img
                                  src={
                                    item.authorImg ||
                                    "assets/img/home1/auction-card-author-img5.png"
                                  }
                                  alt=""
                                />
                              </div>
                              <div className="author-content">
                                <h6>{item.authorName || "Aiden Joseph"}</h6>
                              </div>
                            </Link>
                            <Link to={`/detail/${item.id}`} className="bid-btn">
                              Bid Now
                            </Link>
                          </div> */}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="row mb-60">
            <div className="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div
                className="section-title wow animate fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                style={{ visibility: "hidden" }}
              >
                <h2 style={{ display: "none", marginTop: "5px" }}>
                  Most Active<span>Bids</span>
                </h2>
                {/* <p>
                  Feel free adapt this based on the specific managed services,
                  features
                </p> */}
              </div>
              <Link
                to="/product-list/mostactive"
                className="view-button wow animate fadeInRight"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                href="auction-grid.html"
              >
                View All Auction
                <svg viewBox="0 0 13 20">
                  <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="latest-auction-section mb-110">
        <div className="container">
          <div className="row mb-60">
            <div className="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div
                className="section-title wow animate fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <h2>
                  No One <span>Won</span>
                </h2>
                {/* <p>
                  Feel free adapt this based on the specific managed services,
                  features
                </p> */}
              </div>
              <Link
                to="/product-list/nowon"
                className="view-button wow animate fadeInRight"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                href="auction-grid.html"
                style={{ visibility: "hidden", display: "none" }}
              >
                View All Auction
                <svg viewBox="0 0 13 20">
                  <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
                </svg>
              </Link>
            </div>
          </div>
          <div className="row g-4">
            {loading
              ? [...Array(8)].map((_, index) => (
                <div
                  key={index}
                  className="col-xl-3 col-lg-3 col-md-4 col-sm-6 wow animate fadeInDown"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="auction-card">
                    <div className="auction-card-img-wrap">
                      <div className="card-img">
                        <Skeleton height={200} />
                      </div>
                    </div>
                    <div className="auction-card-content">
                      <h6>
                        <Skeleton width={`80%`} />
                      </h6>
                      <div className="price-and-code-area">
                        <div className="price">
                          <Skeleton width={100} />
                        </div>
                        <div className="code">
                          <Skeleton width={50} />
                        </div>
                      </div>
                      <div className="author-and-btn-area">
                        <div className="author-area d-flex align-items-center">
                          <Skeleton circle height={40} width={40} />
                          <Skeleton width={100} style={{ marginLeft: 10 }} />
                        </div>
                        <div
                          className="bid-btn"
                          style={{ background: "transparent" }}
                        >
                          <Skeleton width={80} height={30} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
              : NoWin.map((item, index) => (
                <div
                  key={index}
                  className="col-xl-3 col-lg-3 col-md-4 col-sm-6 m-0 p-0 wow animate fadeInDown"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="auction-card">
                    <div
                      className="auction-card-img-wrap"
                      style={{ position: "relative", overflow: "hidden" }}
                    >
                      <Link to={`/detail/${item.id}`} className="card-img">
                        <img
                          src={
                            item.photo
                              ? `${BASE_URL}/${item.photo
                                .split(",")[0]
                                .trim()}`
                              : `${BASE_URL}/uploads/logo/icon.png`
                          }
                          loading="lazy"
                          alt={item.title || "FastTrade Product"}
                          title={item.title || "FastTrade Product"}
                        />
                      </Link>
                      <ul className="bookmark_icon">
                        <li>
                          {favloading[item.id] ? (
                            <span className="fav-spinner"></span>
                          ) : (
                            <Link
                              to="#/"
                              onClick={() => {
                                bookmarks.some(
                                  (items) => items.id === item.id
                                )
                                  ? removefav(item.id)
                                  : addToFavorite(item.id);
                              }}
                            >
                              {/* Eye Icon */}
                              <FontAwesomeIcon
                                icon={faHeart}
                                style={{
                                  color: bookmarks.some(
                                    (items) => items.id === item.id
                                  )
                                    ? "#F2B42A"
                                    : "",
                                  borderRadius: "50%",
                                }}
                              />
                            </Link>
                          )}
                        </li>
                      </ul>
                      {item.membership_type !== "Basic" && (
                        <p
                          className="tag"
                          style={{
                            position: "absolute",
                            top: 15,
                            left: "-23px",
                            margin: 0,
                            background:
                              item.membership_type === "Gold"
                                ? "#F2B42A"
                                : item.membership_type === "Silver"
                                  ? "#C0C0C0"
                                  : "#ffffff", // fallback
                            padding: "0px 22px",
                            textAlign: "center",
                            borderRadius: "2px",
                            color: "black",
                            fontWeight: 800,
                            transform: "rotate(309deg)"
                          }}
                        >
                          {item.membership_type}
                        </p>
                      )}
                    </div>

                    <div className="auction-card-content">
                      {/* <UserReviewInfo userId={item.user_id} /> */}
                      <div
                        className="price-and-code-area"
                        style={{ marginBottom: "5px", marginTop: "10px" }}
                      >
                        <div className="price">
                          <span
                            style={{
                              fontSize: "15px",
                              color: "#91948F",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              gap: "1px",
                            }}
                          >
                            {" "}
                            <FaMapMarkerAlt
                              style={{ color: "#91948F", fontSize: "14px" }}
                            />{" "}
                            {item.city?.length > 15
                              ? item.city.substring(0, 15) + "..."
                              : item.city}
                          </span>
                        </div>
                        <div className="code"># {item.id}</div>
                      </div>
                      <h6 className="two-line-title product_title">
                        <Link to={`/detail/${item.id}`}>
                          {item.title || "Untitled Auction"}
                        </Link>
                      </h6>

                      <div className="price-and-code-area">
                        <div className="price">
                          <span>Current Bid at:</span>
                          <strong>{item.current_price || "0.00"} SAR</strong>
                        </div>
                        {Number(item.current_price) / Number(item.buy_now) >=
                          buyNowLimit ? (
                          ""
                        ) : Number(item.buy_now) == 0 ? (
                          ""
                        ) : (
                          <div className="price">
                            <span>Buy Now at:</span>
                            <strong>{Number(item.buy_now)} SAR</strong>
                          </div>
                        )}
                      </div>

                      <div className="relise">
                        {relistloading[item.id] ? (
                          // 🌀 Show loader or loading text
                          <p
                            style={{
                              color: "#ff0505ff",
                              margin: 0,
                              fontWeight: "600",
                            }}
                          >
                            Requesting...
                          </p>
                        ) : relistuser?.data?.some(
                          (entry) =>
                            String(entry.user_id) === String(user_id) &&
                            String(entry.product_id) === String(item.id)
                        ) ? (
                          <p
                            style={{
                              color: "green",
                              fontWeight: "bold",
                              margin: "0",
                            }}
                          >
                            You applied for relist
                          </p>
                        ) : (
                          <button
                            onClick={() => relist(item.id, item.user_id)}
                          >
                            {relistloading[item.id]
                              ? "Requesting....."
                              : "Please Relist item again"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="row mb-60">
            <div className="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div
                className="section-title wow animate fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                style={{ visibility: "hidden" }}
              >
                <h2 style={{ display: "none", marginTop: "5px" }}>
                  No One <span>Win</span>
                </h2>
                {/* <p>
                  Feel free adapt this based on the specific managed services,
                  features
                </p> */}
              </div>
              <Link
                to="/product-list/nowon"
                className="view-button wow animate fadeInRight"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                href="auction-grid.html"
              >
                View All Auction
                <svg viewBox="0 0 13 20">
                  <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {showToast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 9999,
          }}
        >
          {toastMessage}
        </div>
      )}

      <Fotter />
    </>
  );
}
